export type ApiSetTechQueryRequest = { query_body: string, comment?: string }[];

export type ApiSetTechQueryResponse = string;

export const SetTechQuery = Symbol('SetTechQuery');

export interface SetTechQuery {
    setTechQuery(data: ApiSetTechQueryRequest): Promise<ApiSetTechQueryResponse>;
}